import { Option } from 'custom/SelectInput';

export function parseOptionValues(optionValues: string): Option[] {
  if (!optionValues) {
    return [];
  }
  return optionValues.split(',').map((val) => {
    let _value = val.trim();
    const index = _value.indexOf(':');
    let _label = _value;
    if (index !== -1) {
      _label = _value.substring(index + 1).trim();
      _value = _value.substring(0, index).trim();
    }
    return { value: _value, label: _label };
  });
}
